<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.bargains'), $t('text.list')]">
        <el-button
          v-if="Permit.canActionsChargeEdition('orderManage')"
          type="success"
          size="mini"
          @click="$router.push('/normal/oms/bargains/new')"
          >+ {{ $t("text.create") }}</el-button
        >
        <el-button
          v-if="
            Permit.canActionsChargeEdition('orderManage') &&
            [2408].includes(Permit.currentTenant().id)
          "
          type="default"
          size="mini"
          @click="$router.push('/normal/oms/bargains/pdf')"
          >{{ $t("action.import") }}(pdf)</el-button
        >
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.serialNoInnerSerialNo')"
          />
        </el-form-item>

        <customer-search
          v-model="searchForm"
          fieldId="customerId"
          fieldName="customerName"
        />

        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.categoryName"
            :placeholder="$t('menu.categories')"
            filterable
            clearable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.specJson"
            :placeholder="$t('product.specJson')"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.customerType"
            :placeholder="$t('bargain.customerType')"
            filterable
            clearable
          >
            <el-option
              v-for="customerType in customerTypes"
              :key="customerType"
              :label="$t('customerTypes.' + customerType)"
              :value="customerType"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="handOverAt"
            :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
          />
        </el-form-item>

        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model="searchForm.ownerId"
            filterable
            clearable
            :placeholder="$t('text.owner')"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model="searchForm.shopId"
            :placeholder="$t('menu.shops')"
            filterable
            clearable
          >
            <el-option
              v-for="shop in shops"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.remark"
            :placeholder="$t('order.remark')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>

    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              v-if="
                !Permit.isFreeEdition() &&
                Permit.canActionsChargeEdition('orderAddPayment')
              "
              type="warning"
              size="mini"
              :loading="batchPaymentCompletedDoing"
              @click="batchPaymentCompleted"
              >{{ $t("action.paymentCompleted") }}</el-button
            >

            <el-button
              v-if="Permit.canActionsChargeEdition('orderDistributiveOwner')"
              type="info"
              size="mini"
              @click="batchDistributiveOwner"
              class="button-blue"
              >{{ $t("action.distributiveOwner") }}</el-button
            >
            <el-button
              v-if="Permit.canActions('orderManage')"
              type="danger"
              size="mini"
              @click="batchDelete"
              >{{ $t("text.delete") }}</el-button
            >
            <el-dropdown
              v-if="!Permit.isFreeEdition()"
              class="mgl10"
              @command="batchAddGroup"
            >
              <el-button type="default" size="mini">
                {{ $t("action.addGroup") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="group of groups"
                  :key="group"
                  :command="group"
                  >{{ group }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                勾选{{ $t("action.downloadAddress") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="middlePost">{{
                  $t("action.downLoadMiddlePost")
                }}</el-dropdown-item>
                <el-dropdown-item command="ePost">{{
                  $t("action.downLoadEPost")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :loading="loading"
        id="bargainsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        :scroll-y="{ enabled: false }"
        highlight-hover-row
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="groupJson"
          :title="$t('menu.groups')"
          min-width="100"
        >
          <template v-slot="{ row, rowIndex }">
            <span v-if="row.groupJson != null && row.groupJson != ''">
              <div
                v-for="item in JSON.parse(row.groupJson)"
                :key="item"
                class="group"
                :type="item"
                size="small"
              >
                {{ item }}
                <i
                  class="el-tag__close el-icon-close"
                  @click="deleteGroup(row, rowIndex, item)"
                ></i>
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="140"
        >
          <template v-slot="{ row }">
            <div
              class="blue"
              @click="$router.push('/normal/oms/bargainsBulk/show/' + row.id)"
            >
              {{ row.serialNo }}
            </div>
            <div>
              <el-popover placement="right" width="300" trigger="click">
                <div>
                  <div class="lineH24">
                    {{ $t("menu.customers") }}：{{ row.customerName }}
                  </div>
                  <div class="lineH24" v-if="row.customerType != null">
                    {{ $t("bargain.customerType") }}：
                    {{ $t("customerTypes." + row.customerType) }}
                  </div>
                  <div class="lineH24">
                    {{ $t("bargain.customerPhone") }}：
                    {{ row.customerPhone }}
                  </div>
                  <div class="lineH24">
                    {{ $t("tenant.country") }}：
                    <span v-if="row.customerCountry != null">{{
                      $t("countries." + row.customerCountry)
                    }}</span>
                  </div>
                  <div class="lineH24">
                    {{ $t("tenant.province") }}：{{ row.customerProvince }}
                  </div>
                  <div class="lineH24">
                    {{ $t("tenant.city") }}：{{ row.customerCity }}
                  </div>
                  <div class="lineH24">
                    {{ $t("tenant.address") }}：{{ row.customerAddress }}
                  </div>
                  <div class="lineH24">
                    {{ $t("customer.zipcode") }}：{{ row.customerZipcode }}
                  </div>
                  <div class="lineH24">
                    {{ $t("bargain.deliveryRemark") }}：{{ row.deliveryRemark }}
                  </div>
                </div>
                <span slot="reference" class="popover-reference font10">
                  {{ row.customerName }}
                  <span
                    class="font10"
                    v-if="row.customer != null && row.customer.type != null"
                  >
                    ({{ $t("customerTypes." + row.customer.type) }})
                  </span>
                  <span v-if="row.customerCountry != null" class="font10">{{
                    $t("countries." + row.customerCountry)
                  }}</span
                  >{{ row.customerProvince }}
                </span>
              </el-popover>
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="productQty"
          :title="$t('bargain.productQty')"
          min-width="70"
        />
        <vxe-table-column
          field="productNoQty"
          :title="$t('stock.productNoQty')"
          min-width="70"
        >
          <template v-slot="{ row }">
            {{ row.productNoQty }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="amount"
          :title="$t('bargain.amount')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.amount }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="settleType"
          :title="$t('bargain.settleType')"
          min-width="120"
        >
          <template v-slot="{ row }">
            {{ $t("settleTypes." + row.settleType) }}
            <span v-if="row.settleType == 'now'" class="font10">
              {{ $t("bargain.receive") }}:
              <currency :code="row.currency"></currency>
              {{ row.payAmount }}

              <div>
                <span v-if="row.ignoreAmount > 0" class="font10">
                  {{ $t("bargain.ignore") }}:
                  <currency :code="row.currency"></currency>
                  {{ row.ignoreAmount }}
                </span>
              </div>
              <div class="font10">
                <span v-if="row.differAmount > 0" class="red font10">
                  {{ $t("bargain.differ") }}:
                  <currency :code="row.currency"></currency>
                  {{ row.differAmount }}
                </span>
                <span v-if="row.differAmount == 0" class="green font10">{{
                  $t("bargain.settled")
                }}</span>
                <span v-if="row.differAmount < 0" class="orange font10">
                  {{ $t("bargain.leave") }}:
                  <currency :code="row.currency"></currency>
                  {{ row.differAmount * -1 }}
                </span>
              </div>
            </span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="12"
              type="richText"
            />
            <raw-html-limit-number
              :content="row.deliveryRemark"
              :number="12"
              style="color: #ff9b6a"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.shopName }}
            <div class="font10">{{ row.ownerName }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column
          field="financeAudit"
          :title="$t('bargain.financeVerifyInfo')"
          min-width="150"
        >
          <template v-slot="{ row }">
            <div v-if="row.financeAudit != null" class="font12 float-left">
              <el-popover placement="right" width="300" trigger="click">
                <div>
                  <div class="lineH24">
                    {{ $t("verify.commentName") }}:
                    {{ row.financeAudit.commentName }}
                  </div>
                  <div class="lineH24">
                    {{ $t("verify.commentAt") }}:
                    {{ row.financeAudit.commentAt }}
                  </div>
                  <div
                    v-if="row.financeAudit.dealType == 'reject'"
                    class="lineH24"
                  >
                    {{ $t("verify.comment") }}:
                    {{ row.financeAudit.comment }}
                  </div>
                </div>
                <span
                  slot="reference"
                  class="popover-reference"
                  :class="
                    row.financeAudit.dealType == 'agree'
                      ? 'green-shallow'
                      : 'red'
                  "
                  >{{ $t("action.verify") }}({{
                    $t("verifyTypesSimple." + row.financeAudit.dealType)
                  }})</span
                >
              </el-popover>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" :title="$t('text.action')" width="120">
          <template v-slot="{ row, rowIndex }">
            <el-dropdown
              v-if="
                row.productQty != 0 &&
                Permit.canActionsChargeEdition('orderManage')
              "
              class="mgr10"
            >
              <a class="el-dropdown-link small-link">
                {{ $t("text.edit") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div class="font10" @click="editBargain(row, rowIndex)">
                    {{ $t("text.edit") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="editBargainHurry(row, rowIndex)" class="font10">
                    {{ $t("action.editBargainHurry") }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown>
              <a class="el-dropdown-link small-link">
                {{ $t("text.more") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div class="font10" @click="copyBargain(row)">
                    {{ $t("action.copy") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="font10" @click="confirmBargain(row)">
                    {{ $t("order.confirm") }}
                  </div>
                </el-dropdown-item>
                <!-- row.productQty == 0 && -->
                <el-dropdown-item
                  v-if="
                    Permit.canActionsChargeEdition('orderManage') &&
                    financeVerifyInfoDF(row)
                  "
                >
                  <div class="font10" @click="deleteBargain(row)">
                    {{ $t("text.delete") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="Permit.canActionsChargeEdition('orderManage')"
                >
                  <div class="font10" @click="addOrder(row)">
                    {{ $t("action.addProducts") }}
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    row.settleType == 'now' &&
                    Permit.canActionsChargeEdition('orderAddPayment')
                  "
                >
                  <div class="font10" @click="addPayment(row, rowIndex)">
                    {{ $t("action.addReceiveAndPayment") }}
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    Permit.canActionsChargeEdition('orderDistributiveOwner') &&
                    financeVerifyInfoDF(row)
                  "
                >
                  <div class="font10" @click="distributiveOwner(row, rowIndex)">
                    {{ $t("action.distributiveOwner") }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div>
              <el-dropdown
                class="mgr10"
                v-if="Permit.canActionsChargeEdition('orderManage')"
              >
                <a class="el-dropdown-link small-link">
                  {{ $t("action.print") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </a>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div
                      class="font10"
                      @click="printSalesSlip(row, 'printSalesSlipDiv')"
                    >
                      {{ $t("action.printSaleOrderWhole") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      class="font10"
                      @click="printSalesSlip(row, 'printSalesSlipSimpleDiv')"
                    >
                      {{ $t("action.printSaleOrderSimple") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      class="font10"
                      @click="printSalesSlip(row, 'printByProductNoColorDiv')"
                    >
                      {{ $t("action.printByProductNoColor") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-for="(pt, index) of printTemplatesSaleSlip"
                    :key="index"
                    :divided="index == 0 ? true : false"
                  >
                    <div class="font10" @click="printSalesSlip(row, pt)">
                      {{ pt.name }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span> 条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- 收款 -->
    <el-dialog
      :title="$t('action.addReceiveAndPayment')"
      :close-on-click-modal="false"
      :visible.sync="addPaymentDF"
      width="30%"
      destroy-on-close
    >
      <el-form
        ref="addPaymentObjForm"
        :model="addPaymentObj"
        label-width="60px"
      >
        <el-row>
          <el-col :span="24" class="center">
            <el-radio-group v-model="addPaymentObj.type" size="small">
              <el-radio-button label="receivables">
                {{ $t("action.payment") }}
              </el-radio-button>
              <el-radio-button label="return">
                {{ $t("action.paymentReturn") }}
              </el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-form-item
          :label="$t('payment.total')"
          :prop="'total'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.total')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addPaymentObj.total"
            @blur="blurJudgeBalance"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('payment.payMethod')"
          :prop="'payMethodId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.payMethod')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="addPaymentObj.payMethodId"
            clearable
            filterable
            @change="blurJudgeBalance"
          >
            <el-option
              v-for="payMethod in payMethods"
              :key="payMethod.id"
              :label="payMethod.name"
              :value="payMethod.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('payment.paidAt')"
          :prop="'paidAt'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.paidAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            size="small"
            v-model="addPaymentObj.paidAt"
            type="date"
            style="width: 100%"
            :picker-options="pickerOptionsFiveDays"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('payment.explain')" :prop="'explain'">
          <el-input size="small" v-model.trim="addPaymentObj.explain" />
        </el-form-item>
        <el-form-item :label="$t('payment.voucher')" :prop="'voucher'">
          <dropzone v-model="addPaymentObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="addPaymentDoing"
          size="small"
          @click="addPaymentSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addPaymentDF = false">
          {{ $t("text.close") }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 分配拥有人 -->
    <el-dialog
      :title="$t('action.distributiveOwner')"
      :close-on-click-modal="false"
      :visible.sync="distributiveOwnerDF"
      width="30%"
    >
      <el-form ref="distributiveOwnerObjForm" :model="distributiveOwnerObj">
        <el-form-item
          :prop="'ownerId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.owner')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="distributiveOwnerObj.ownerId"
            clearable
            filterable
          >
            <el-option
              v-for="user in usersFilterValid"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="distributiveOwnerDoing"
          size="small"
          @click="distributiveOwnerSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="distributiveOwnerDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.copy')"
      :close-on-click-modal="false"
      v-if="copyBargainDF"
      :visible.sync="copyBargainDF"
      width="30%"
    >
      <copy-bargain
        :id="currentRowBargainId"
        @updated="copyUpdated"
        @close="copyBargainDF = false"
      />
    </el-dialog>

    <!-- ===== -->
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="showBargainDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-bargain :id="currentRowBargainId" />
    </drawer>

    <drawer
      :title="$t('text.edit', [$t('menu.bargains')])"
      :visible.sync="editBargainDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit-bargain :id="currentRowBargainId" @updateInfo="bargainUpdated" />
    </drawer>
    <!-- ===== -->
    <drawer
      :title="$t('text.create', [$t('menu.orders')])"
      :visible.sync="addOrderDF"
      size="800px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <new-order :uuid="currentRowBargainUuid" @updateInfo="addOrderClose" />
    </drawer>

    <!-- 完成销售单 -->
    <div id="printSalesSlipDiv" style="display: none">
      <div style="width: 100%; font-size: 12px">
        <div style="text-align: center; font-size: 18px">
          {{ Permit.currentTenant().name }}{{ $t("bargain.salesSlip") }}
        </div>
        <div style="text-align: center; font-size: 16px">
          {{ printBargain.shopName }}&nbsp;&nbsp;{{ printBargain.ownerName }}
        </div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            text-align: left;
            margin-bottom: 20px;
            padding: 5px;
            font-size: 12px;
          "
        >
          <tr
            style="border: 1px solid black; text-align: left; padding-left: 5px"
          >
            <td style="border: 1px solid black; padding: 5px" colspan="16">
              {{ $t("bargain.customerName") }}：{{
                printBargain.customerName
              }}
              &nbsp;&nbsp;&nbsp;&nbsp; {{ $t("bargain.customerPhone") }}：{{
                printBargain.customerPhone
              }}
              <span style="float: right">
                {{ $t("bargain.customerAddress") }}：
                <span v-if="printBargain.customerCountry != null">{{
                  $t("countries." + printBargain.customerCountry)
                }}</span>
                {{ printBargain.customerProvince || ""
                }}{{ printBargain.customerCity || ""
                }}{{ printBargain.customerAddress || "" }}&nbsp;&nbsp;
              </span>
            </td>
          </tr>

          <tr style="border: 1px solid black; text-align: center">
            <td style="border: 1px solid black; width: 60px; padding: 5px">
              #
            </td>
            <td style="border: 1px solid black; width: 120px">
              {{ $t("order.serialNo") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.brand") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.category") }}
            </td>
            <td style="border: 1px solid black; width: 100px">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.color") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.size") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.quantity") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("order.productPrice") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("order.discountRate2") }}
            </td>
            <td style="border: 1px solid black; width: 80px">
              {{ $t("order.price") }}
            </td>
            <td style="border: 1px solid black; width: 80px">
              {{ $t("order.extraCharge") }}
            </td>
            <td style="border: 1px solid black; width: 80px">
              {{ $t("order.subtotal") }}
            </td>
            <td style="border: 1px solid black">
              {{ $t("text.handOverAt2") }}
            </td>
          </tr>
          <span
            v-for="(item, itemIndex) in printBargain.orders"
            :key="itemIndex"
          >
            <tr style="border: 1px solid black; text-align: center">
              <td style="border: 1px solid black; padding: 5px">
                {{ itemIndex + 1 }}
              </td>
              <td style="border: 1px solid black">{{ item.serialNo }}</td>
              <td style="border: 1px solid black">
                {{ item.productBrand || "" }}
              </td>
              <td style="border: 1px solid black">
                {{ item.categoryName || "" }}
              </td>
              <td style="border: 1px solid black">{{ item.productNo }}</td>
              <td style="border: 1px solid black">{{ item.color || "" }}</td>
              <td style="border: 1px solid black">{{ item.size || "" }}</td>
              <td style="border: 1px solid black">
                {{ item.quantity }}{{ item.unit }}
              </td>
              <td style="border: 1px solid black">{{ item.productPrice }}</td>
              <td style="border: 1px solid black">
                <span
                  v-if="item.discountRate != null && item.discountRate != 0"
                  >{{ item.discountRate }}</span
                >
              </td>
              <td style="border: 1px solid black">
                <currency :code="item.currency"></currency>
                {{ item.price }}
              </td>
              <td style="border: 1px solid black">
                <currency
                  v-if="item.extraCharge != null && item.extraCharge != 0"
                  :code="item.currency"
                ></currency>
                {{ item.extraCharge }}
              </td>
              <td style="border: 1px solid black">
                <currency :code="item.currency"></currency>
                {{
                  Util.toFixed(item.quantity * item.price + item.extraCharge, 3)
                }}
              </td>
              <td style="border: 1px solid black">{{ item.handOverAt }}</td>
            </tr>
            <tr v-if="item.remark !== null && item.remark !== ''">
              <td style="border: 1px solid black">{{ $t("text.remark") }}:</td>
              <td style="border: 1px solid black" colspan="18">
                <raw-html :content="item.remark"></raw-html>
              </td>
            </tr>
          </span>
          <tr style="border: 1px solid black; text-align: left">
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("bargain.receivePaymentInfo") }}：
            </td>
            <td style="border: 1px solid black; padding: 5px" colspan="18">
              {{ $t("bargain.ordersTotal") }}：
              <currency :code="printBargain.currency"></currency>
              {{ printBargain.amount }}&nbsp;&nbsp;&nbsp;&nbsp;
              {{ $t("bargain.actualReceive") }}：
              <currency :code="printBargain.currency"></currency>
              {{ printBargain.payAmount }}&nbsp;&nbsp;&nbsp;&nbsp;
              <span v-if="printBargain.ignoreAmount > 0">
                {{ $t("payment.ignoreAmount") }}：
                <currency :code="printBargain.currency"></currency>
                {{ printBargain.ignoreAmount }}&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span v-if="printBargain.differAmount > 0">
                {{ $t("bargain.differReceive") }}：
                <currency :code="printBargain.currency"></currency>
                {{ printBargain.differAmount }}&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span v-if="printBargain.differAmount < 0">
                {{ $t("bargain.leavePayAmount") }}：
                <currency :code="printBargain.currency"></currency>
                {{ -printBargain.differAmount }}&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </td>
          </tr>
          <tr style="border: 1px solid black; text-align: left">
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("bargain.remark") }}：
            </td>
            <td style="border: 1px solid black; padding: 5px" colspan="18">
              <raw-html :content="printBargain.remark"></raw-html>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 精简销售单 -->
    <div id="printSalesSlipSimpleDiv" style="display: none">
      <div style="width: 100%; font-size: 12px">
        <div style="text-align: center; font-size: 18px">
          {{ Permit.currentTenant().name }}{{ $t("bargain.salesSlip") }}
        </div>
        <div style="text-align: center; font-size: 16px">
          {{ printBargain.shopName }}&nbsp;&nbsp;{{ printBargain.ownerName }}
        </div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            text-align: left;
            margin-bottom: 20px;
            padding: 5px;
            font-size: 12px;
          "
        >
          <tr
            style="border: 1px solid black; text-align: left; padding-left: 5px"
          >
            <td style="border: 1px solid black; padding: 5px" colspan="16">
              {{ $t("bargain.customerName") }}：{{
                printBargain.customerName
              }}
              &nbsp;&nbsp;&nbsp;&nbsp; {{ $t("bargain.customerPhone") }}：{{
                printBargain.customerPhone
              }}
              <span style="float: right">
                {{ $t("bargain.customerAddress") }}：
                <span v-if="printBargain.customerCountry != null">{{
                  $t("countries." + printBargain.customerCountry)
                }}</span>
                {{ printBargain.customerProvince || ""
                }}{{ printBargain.customerCity || ""
                }}{{ printBargain.customerAddress || "" }}&nbsp;&nbsp;
              </span>
            </td>
          </tr>

          <tr style="border: 1px solid black; text-align: center">
            <td style="border: 1px solid black; width: 60px; padding: 5px">
              #
            </td>
            <td style="border: 1px solid black; width: 160px">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.color") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.size") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.quantity") }}
            </td>
            <td style="border: 1px solid black; width: 80px">
              {{ $t("order.price") }}
            </td>
            <td style="border: 1px solid black; width: 80px">
              {{ $t("order.extraCharge") }}
            </td>
            <td style="border: 1px solid black">
              {{ $t("order.subtotal") }}
            </td>
            <td style="border: 1px solid black">
              {{ $t("text.handOverAt2") }}
            </td>
          </tr>
          <span
            v-for="(item, itemIndex) in printBargain.orders"
            :key="itemIndex"
          >
            <tr style="border: 1px solid black; text-align: center">
              <td style="border: 1px solid black; padding: 5px">
                {{ itemIndex + 1 }}
              </td>
              <td style="border: 1px solid black">{{ item.productNo }}</td>
              <td style="border: 1px solid black">{{ item.color || "" }}</td>
              <td style="border: 1px solid black">{{ item.size || "" }}</td>
              <td style="border: 1px solid black">
                {{ item.quantity }}{{ item.unit }}
              </td>
              <td style="border: 1px solid black">
                <currency :code="item.currency"></currency>
                {{ item.price }}
              </td>
              <td style="border: 1px solid black">
                <currency
                  v-if="item.extraCharge != null && item.extraCharge != 0"
                  :code="item.currency"
                ></currency>
                {{ item.extraCharge }}
              </td>
              <td style="border: 1px solid black">
                <currency :code="item.currency"></currency>
                {{
                  Util.toFixed(item.quantity * item.price + item.extraCharge, 3)
                }}
              </td>
              <td style="border: 1px solid black">{{ item.handOverAt }}</td>
            </tr>
            <tr v-if="item.remark !== null && item.remark !== ''">
              <td style="border: 1px solid black">{{ $t("text.remark") }}:</td>
              <td style="border: 1px solid black" colspan="17">
                <raw-html :content="item.remark"></raw-html>
              </td>
            </tr>
          </span>
          <tr style="border: 1px solid black; text-align: left">
            <td style="border: 1px solid black; width: 60px">
              {{ $t("bargain.receivePaymentInfo") }}：
            </td>
            <td style="border: 1px solid black; padding: 5px" colspan="16">
              {{ $t("bargain.ordersTotal") }}：
              <currency :code="printBargain.currency"></currency>
              {{ printBargain.amount }}&nbsp;&nbsp;&nbsp;
              {{ $t("bargain.actualReceive") }}：
              <currency :code="printBargain.currency"></currency>
              {{ printBargain.payAmount }}&nbsp;&nbsp;&nbsp;&nbsp;
              <span v-if="printBargain.ignoreAmount > 0">
                {{ $t("bargain.ignoreAmount") }}：
                <currency :code="printBargain.currency"></currency>
                {{ printBargain.ignoreAmount }}&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span v-if="printBargain.differAmount > 0">
                {{ $t("bargain.differReceive") }}：
                <currency :code="printBargain.currency"></currency>
                {{ printBargain.differAmount }}&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span v-if="printBargain.differAmount < 0">
                {{ $t("bargain.leavePayAmount") }}：
                <currency :code="printBargain.currency"></currency>
                {{ -printBargain.differAmount }}&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </td>
          </tr>
          <tr style="border: 1px solid black; text-align: left">
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("bargain.remark") }}：
            </td>
            <td style="border: 1px solid black; padding: 5px" colspan="17">
              <raw-html :content="printBargain.remark"></raw-html>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 自定义销售单 -->
    <div id="printSalesSlipCustomDiv" style="display: none">
      <div id="customPrintContentSalesSlip" />
    </div>

    <!-- 打印 -->
    <el-dialog
      :title="$t('action.print')"
      :close-on-click-modal="false"
      :visible.sync="printByProductNoColorDF"
      width="50%"
    >
      <vxe-table
        :data="printByProductNoColorArrs"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="customerProductNoArrs"
          :title="'客号'"
          min-width="85"
        >
          <template v-slot="{ row }">
            {{ row.customerProductNoArrs.join("/") }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        ></vxe-table-column>
        <vxe-table-column
          field="color"
          :title="$t('product.color')"
          min-width="80"
        ></vxe-table-column>
        <vxe-table-column
          field="subQuantity"
          :title="$t('text.total')"
          min-width="80"
        ></vxe-table-column>
        <vxe-table-column
          field="handOverAtArrs"
          :title="$t('text.handOverAt')"
          min-width="85"
        >
          <template v-slot="{ row }">
            {{ row.handOverAtArrs.join("/") }}
          </template>
        </vxe-table-column>
      </vxe-table>
      <div slot="footer" class="dialog-footer">
        {{ $t("text.total") }}：{{ printBargain.productQty }}
        <el-button
          type="primary"
          plain
          size="small"
          @click="print('printByProductNoColorDiv')"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="printByProductNoColorDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 按照货号颜色 -->
    <div id="printByProductNoColorDiv" style="display: none">
      <div style="width: 100%; font-size: 12px">
        <div style="text-align: center; font-size: 18px">
          <span>{{ Permit.currentTenant().name }}&nbsp;订单汇总表</span>
          <span style="float: right; font-size: 14px">
            {{ $t("order.giveAt") }}：{{ printBargain.createAt }}
          </span>
        </div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            text-align: left;
            margin-bottom: 20px;
            padding: 5px;
            font-size: 12px;
          "
        >
          <tr
            style="
              border: 1px solid black;
              text-align: center;
              padding-left: 5px;
            "
          >
            <td
              style="border: 1px solid black; text-align: center; padding: 5px"
            >
              {{ $t("bargain.customerName") }}
            </td>
            <td style="border: 1px solid black; text-align: left; padding: 5px">
              {{ printBargain.customerName }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; padding: 5px"
            >
              {{ $t("bargain.serialNo") }}
            </td>
            <td style="border: 1px solid black; text-align: left; padding: 5px">
              {{ printBargain.serialNo }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; padding: 5px"
              :colspan="printSizesArrs.length"
            >
              尺码
            </td>
            <td
              style="border: 1px solid black; text-align: left; padding: 5px"
              colspan="2"
            ></td>
          </tr>

          <tr style="border: 1px solid black; text-align: center">
            <td style="border: 1px solid black; width: 120px; padding: 5px">
              客号
            </td>
            <td style="border: 1px solid black; width: 120px">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid black; width: 100px">
              {{ $t("product.color") }}
            </td>
            <td style="border: 1px solid black">
              {{ $t("text.remark") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-for="(size, sizeIndex) of printSizesArrs"
              :key="sizeIndex"
            >
              {{ size }}
            </td>
            <td style="border: 1px solid black; width: 80px">
              {{ $t("order.subtotal") }}
            </td>
            <td style="border: 1px solid black; width: 120px">
              {{ $t("text.handOverAt") }}
            </td>
          </tr>
          <span
            v-for="(item, itemIndex) in printByProductNoColorArrs"
            :key="itemIndex"
          >
            <tr style="border: 1px solid black; text-align: center">
              <td style="border: 1px solid black; padding: 5px">
                {{ item.customerProductNoArrs.join("/") }}
              </td>
              <td style="border: 1px solid black">{{ item.productNo }}</td>
              <td style="border: 1px solid black">{{ item.color || "" }}</td>
              <td style="border: 1px solid black">
                <span v-if="item.remarkArrs.length != 0">
                  <div
                    v-for="(remark, remarkIndex) of item.remarkArrs"
                    :key="remarkIndex"
                  >
                    <raw-html :content="remark" type="richText"></raw-html>
                  </div>
                </span>
              </td>
              <td
                style="border: 1px solid black"
                v-for="(size, sizeIndex) of printSizesArrs"
                :key="sizeIndex"
              >
                {{ printComputeSizeQty(item, size) }}
              </td>
              <td style="border: 1px solid black">
                {{ item.subQuantity }}
              </td>
              <td style="border: 1px solid black">
                {{ item.handOverAtArrs.join("/") }}
              </td>
            </tr>
          </span>
          <tr style="border: 1px solid black; text-align: left">
            <td
              style="border: 1px solid black; text-align: left; padding: 5px"
              :colspan="4 + printSizesArrs.length"
            >
              {{ $t("bargain.remark") }}：<raw-html
                :content="printBargain.remark"
              ></raw-html>
            </td>
            <td style="border: 1px solid black; padding: 5px" colspan="2">
              {{ $t("text.total") }}: {{ printBargain.productQty }}
            </td>
          </tr>
          <tr style="border: 1px solid black">
            <td
              style="border: 1px solid black; padding: 5px; text-align: right"
              :colspan="6 + printSizesArrs.length"
            >
              制单人：{{
                printBargain.ownerName
              }}
              &nbsp;&nbsp;&nbsp;打印日期：{{ Util.formatDate(new Date()) }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <el-dialog
      :title="$t('action.print')"
      :close-on-click-modal="false"
      :visible.sync="confirmPrintDF"
      width="30%"
    >
      <div class="font10 center">确认打印？</div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          size="small"
          @click="confirmPrintSubmit()"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="confirmPrintDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import ls from "store2";
import Cookies from "js-cookie";

import { table, page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";

import {
  flagsWithClear,
  flagsWithNone,
  customerTypes,
  countriesCN,
} from "@/utils/enums.js";
import {
  orderTitle,
  orderTitleSimple,
  orderTitleWidthImage,
  orderTitleSimpleWidthImage,
} from "../bargains/customPrintTitle.js";
import DateRange from "@/components/DateRange";
import Currency from "@/components/Currency";
import RawHtml from "@/components/RawHtml";
import ThumbnailText from "@/components/ThumbnailText";
import Dropzone from "@/components/Dropzone";
import CustomerSearch from "@/components/CustomerSearch";

//
import Bargain from "@/api/bargain.js";
import Order from "@/api/order.js";
import User from "@/api/user.js";
import Category from "@/api/category.js";
import Enumeration from "@/api/enumeration.js";
import Shop from "@/api/shop.js";
import PrintTemplate from "@/api/printTemplate.js";
import Payment from "@/api/payment";
import PayMethod from "@/api/payMethod";
import Customer from "@/api/customer";
import Brand from "@/api/brand";

//
import ShowBargain from "../bargains/showBargain.vue";
import EditBargain from "../bargains/editBargain.vue";

import CopyBargain from "../bargains/copyBargain.vue";
import CopyOrder from "../bargains/copyOrder.vue";
import NewOrder from "../bargains/newOrder.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    Currency,
    RawHtml,
    ThumbnailText,
    Dropzone,
    CustomerSearch,

    ShowBargain,
    EditBargain,
    CopyBargain,
    CopyOrder,
    NewOrder,
  },

  data() {
    return {
      Util: Util,
      flagsWithClear: flagsWithClear,
      flagsWithNone: flagsWithNone,
      customerTypes: customerTypes,
      sorter: {
        sortBy: "bargains_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        handOverAt: "orders.hand_over_at",
      },
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: Order.nearRange,
          },
          {
            label: this.$t("order.passRange"),
            items: Order.passRange,
          },
          {
            label: this.$t("text.flag"),
            items: flagsWithNone.map((flag) => {
              return { flag: flag, key: flag, condition: { flag: flag } };
            }),
          },
        ],
        [
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
              {
                label: this.$t("settleInfo.no"),
                key: "unSettleNo",
                condition: { unsettle: "no" },
              },
              {
                label: this.$t("bargain.settled"),
                key: "zero",
                condition: { payInfo: "zero" },
              },
              {
                label: this.$t("order.debt"),
                key: "debt",
                condition: { payInfo: "debt" },
              },
              {
                label: this.$t("order.balance"),
                key: "balance",
                condition: { payInfo: "balance" },
              },
              {
                label: this.$t("order.unComplated"),
                key: "unComplated",
                condition: {
                  workflowStates: [
                    "placed",
                    "pending",
                    "preparing",
                    "prepared",
                    "processing",
                    "processed",
                    "purchasing",
                    "purchased",
                    "shipped",
                    "partially",
                  ],
                },
              },
            ],
          },
          {
            label: this.$t("order.orderResource"),
            items: [
              {
                label: "手动录入的",
                key: "entryMethodManual",
                condition: { entryMethod: "manual" },
              },
              {
                label: "自动导入的",
                key: "entryMethodAuto",
                condition: { entryMethod: "auto" },
              },
              // {
              //   label: this.$t("orderResources.followYes"),
              //   key: "followYes",
              //   condition: { follow: "yes" },
              // },

              {
                label: this.$t("orderResources.followNo"),
                key: "followNo",
                condition: { follow: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: null,
      searchForm: {
        keyword: null,
        customerId: null,
        customerName: null,
        productNo: null,
        createAtStartAt: null,
        createAtEndAt: null,
        handOverAtStartAt: null,
        handOverAtEndAt: null,
        ownerId: null,
        shopId: null,
        categoryName: null,
        customerType: null,
        productBrand: null,
        color: null,
        size: null,
        specJson: null,
        remark: null,
      },
      users: [],
      categories: [],
      groups: [],
      shops: [],
      shopsInv: [],
      printTemplatesSaleSlip: [],
      brands: [],
      //
      batchConfirmDoing: false,
      batchPaymentCompletedDoing: false,
      //合并订单
      mergeDF: false,
      mergeSelectedBargains: [],
      mergeBargainId: null,
      mergeBargainDoing: false,

      // 收款
      addPaymentDF: false,
      pickerOptionsFiveDays: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const day = 5 * 24 * 3600 * 1000;
          const threeMonths = curDate - day;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },
      },
      payMethods: [],
      customer: null,
      addPaymentObj: {
        type: "receivables", // return
        total: null,
        payMethodId: null,
        payMethodName: null,
        explain: null,
        currency: null,
        bargainId: null,
        paidAt: null,
        voucher: null,
        settlementId: 0, // 先付款
        customerId: null,
      },
      addPaymentDoing: false,
      // 分配拥有人
      distributiveOwnerType: null,
      distributiveOwnerDF: false,
      distributiveOwnerObj: {
        uuid: null,
        ownerId: null,
        ownerName: null,
      },
      usersFilterValid: [],
      distributiveOwnerDoing: false,

      // 编辑交期
      row: null,
      updateHandOverAtDF: false,
      updateHandOverAtObj: {
        handOverAt: null,
      },
      updateHandOverAtSubmitDoing: false,
      // 设置只能选择今天以后
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      //
      printBargain: { serialNo: null, shopName: null, ownerName: null },
      //=====
      //
      deliveries: [],

      // 取消
      payMethods: [],
      cancelDF: false,
      cancelObj: {
        id: null,
        total: null,
        reason: null,
        payMethodId: null,
        payMethodName: null,
        returnPayment: true,
      },
      cancelDoing: false,
      // 退货
      returnDF: false,
      returnObj: {
        haveGood: true,
        total: null,
        reason: null,
        payMethodId: null,
        payMethodName: null,
        returnTracking: null,
        id: null,
      },
      returnDoing: false,
      // 复制订单
      copyBargainDF: false,
      copyOrderDF: false,
      //
      currentRowIdx: null,
      currentRowBargainId: null,
      currentRowBargainUuid: null,
      currentRowOrderId: null,

      showBargainDF: false,
      editBargainDF: false,

      addOrderDF: false,
      //立即交付
      immediateDeliveryDF: false,
      row: null,
      shopShelfs: [],
      immediateDeliveryOrders: [],
      immediateDeliveryObj: {
        shopId: null,
        shelfId: null,
      },
      immediateDeliveryDoing: false,
      //报价
      editQuotedPriceDF: false,
      editQuotedPriceObj: {
        quotedPrice: null,
      },
      editQuotedPriceSubmitDoing: false,

      //
      printSizesArrs: [],
      printByProductNoColorArrs: [],
      printByProductNoColorDF: false,
      //
      confirmPrintDF: false,
      printType: null,
    };
  },
  created() {
    const self = this;
    if (JSON.stringify(self.$route.query) !== "{}") {
      self.initFilter = self.$route.query.initFilter;
    }
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    self.narrowsWorkflowStates();
    self.narrowsFinanceVerifyInfo();
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Category.findByTenantId(),
        Enumeration.findByType("group"),
        Shop.findByTenantId(),
        PrintTemplate.findByType({ type: "saleSlip" }),
        Brand.findByTenantId(),
      ])
      .then(
        axios.spread(function (
          users,
          categories,
          groups,
          shops,
          saleSlipRes,
          brands
        ) {
          if (users.status === 200) {
            self.users = users.data.filter((u) => u.authorize === true);
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (groups.data.code === 200) {
            self.groups = JSON.parse(groups.data.entity.itemsJson);
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
            self.shopsInv = shops.data.filter((s) => s.isInventory === true);
          } else {
            self.sysError();
          }
          if (saleSlipRes.status === 200) {
            self.printTemplatesSaleSlip = saleSlipRes.data;
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.brands = brands.data;
          } else {
            self.sysError();
          }
          self.narrowsBrandsGroups();
        })
      );
  },
  methods: {
    //==========================
    // 打印客户清单
    printSalesSlip(row, cmd) {
      const self = this;
      self.printBargain = row;

      if (cmd == "printByProductNoColorDiv") {
        Bargain.findById(row.id).then(function (res) {
          if (res.data.code === 200) {
            self.printBargain = res.data.entity;
            if (self.printBargain.orders.length == 0) {
              return;
            }
            self.printSizesArrs = [];
            self.printByProductNoColorArrs = [];
            for (let order of self.printBargain.orders) {
              if (!self.printSizesArrs.includes(order.size)) {
                self.printSizesArrs.push(order.size);
              }
              //
              let printArrsIndex = self.printByProductNoColorArrs.findIndex(
                (p) => p.productNo == order.productNo && p.color == order.color
              );
              if (printArrsIndex == -1) {
                self.printByProductNoColorArrs.push({
                  productNo: order.productNo,
                  color: order.color,
                  sizeArrs: [
                    {
                      size: order.size,
                      quantity: order.quantity,
                      unit: order.unit,
                    },
                  ],
                  subQuantity: order.quantity,
                  customerProductNoArrs: [order.customerProductNo],
                  handOverAtArrs: [order.handOverAt],
                  remarkArrs: [order.remark],
                });
              } else {
                let sizeArrIndex = self.printByProductNoColorArrs[
                  printArrsIndex
                ].sizeArrs.findIndex((s) => {
                  s.size == order.size;
                });
                if (sizeArrIndex == -1) {
                  self.printByProductNoColorArrs[printArrsIndex].sizeArrs.push({
                    size: order.size,
                    quantity: order.quantity,
                    unit: order.unit,
                  });
                } else {
                  self.printByProductNoColorArrs[printArrsIndex].sizeArrs[
                    sizeArrIndex
                  ].quantity =
                    order.quantity +
                    Number(
                      self.printByProductNoColorArrs[printArrsIndex].sizeArrs[
                        sizeArrIndex
                      ].quantity
                    );
                }
                //
                self.printByProductNoColorArrs[printArrsIndex].subQuantity =
                  order.quantity +
                  Number(
                    self.printByProductNoColorArrs[printArrsIndex].subQuantity
                  );
                //
                if (
                  !self.printByProductNoColorArrs[
                    printArrsIndex
                  ].customerProductNoArrs.includes(order.customerProductNo)
                ) {
                  self.printByProductNoColorArrs[
                    printArrsIndex
                  ].customerProductNoArrs.push(order.customerProductNo);
                }
                //
                if (
                  !self.printByProductNoColorArrs[
                    printArrsIndex
                  ].handOverAtArrs.includes(order.handOverAt)
                ) {
                  self.printByProductNoColorArrs[
                    printArrsIndex
                  ].handOverAtArrs.push(order.handOverAt);
                }
                //
                if (
                  !self.printByProductNoColorArrs[
                    printArrsIndex
                  ].remarkArrs.includes(order.remark)
                ) {
                  self.printByProductNoColorArrs[
                    printArrsIndex
                  ].remarkArrs.push(order.remark);
                }
              }
            }
            self.printByProductNoColorDF = true;
          } else {
            self.sysError();
          }
        });
      } else {
        Bargain.findById(row.id).then(function (res) {
          if (res.data.code === 200) {
            self.printBargain = res.data.entity;
            self.printType = cmd;
            self.confirmPrintDF = true;
          } else {
            self.sysError();
          }
        });
      }
    },
    confirmPrintSubmit() {
      const self = this;
      if (
        ["printSalesSlipDiv", "printSalesSlipSimpleDiv"].includes(
          self.printType
        )
      ) {
        self.$nextTick(function () {
          self.print(self.printType);
        });
      } else {
        self.customPrintSubmit(self.printType);
      }
      self.confirmPrintDF = false;
    },
    printComputeSizeQty(item, size) {
      if (item.sizeArrs.find((s) => s.size == size)) {
        return item.sizeArrs.find((s) => s.size == size).quantity;
      }
      return "";
    },
    customPrintSubmit(cmd) {
      const self = this;
      self.customPrintContent = cmd.content;
      let currencySymbol = "";
      const currencyObj = ls
        .session("CURRENCIES")
        .find((r) => r.code === self.printBargain.currency);
      if (currencyObj != null) {
        currencySymbol = currencyObj.symbol;
      } else {
        currencySymbol = self.code;
      }
      self.customPrintContent = self.customPrintContent.replace(
        /\${订单号}/g,
        self.printBargain.serialNo
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${销售额}/g,
        currencySymbol + self.printBargain.productAmount
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${欠款额}/g,
        currencySymbol + self.printBargain.differAmount
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${成交额}/g,
        currencySymbol + self.printBargain.amount
      );
      if (self.printBargain && self.printBargain.settleType === "now") {
        self.customPrintContent = self.customPrintContent.replace(
          /\${收款类型}/g,
          "现结"
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${收款额}/g,
          currencySymbol + self.printBargain.payAmount
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${抹零额}/g,
          currencySymbol + self.printBargain.ignoreAmount
        );
        if (
          self.printBargain.payments &&
          self.printBargain.payments.length != 0
        ) {
          let paymentsInfo = "";
          if (self.printBargain.payments.length === 1) {
            paymentsInfo =
              self.printBargain.payments[0].payMethodName +
              "(" +
              currencySymbol +
              self.printBargain.payments[0].total +
              ") ";
          } else {
            for (const paymentIdx in self.printBargain.payments) {
              const sequence = parseInt(paymentIdx) + 1;
              paymentsInfo =
                paymentsInfo +
                sequence +
                "." +
                self.printBargain.payments[paymentIdx].payMethodName +
                "(" +
                currencySymbol +
                self.printBargain.payments[paymentIdx].total +
                ") ";
            }
          }
          self.customPrintContent = self.customPrintContent.replace(
            /\${收款方式}/g,
            paymentsInfo
          );
        }
      } else {
        self.customPrintContent = self.customPrintContent.replace(
          /\${收款类型}/g,
          "账单结算"
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${收款额}/g,
          "账单结算"
        );
      }
      self.customPrintContent = self.customPrintContent.replace(
        /\${创建日期}/g,
        self.printBargain.createAt
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${销售}/g,
        self.printBargain.ownerName
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${发货备注}/g,
        self.printBargain.deliveryRemark || ""
      );
      let remark = "";
      if (self.printBargain.remark != null) {
        remark = self.printBargain.remark.replace(
          /<p>/g,
          "<p style='margin: 0; padding: 0'>"
        );
      }
      self.customPrintContent = self.customPrintContent.replace(
        /\${订单备注}/g,
        remark
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户姓名}/g,
        self.printBargain.customerName
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户电话}/g,
        self.printBargain.customerPhone
      );
      if (self.printBargain.customerCountry != null) {
        self.customPrintContent = self.customPrintContent.replace(
          /\${客户国家}/g,
          countriesCN[self.printBargain.customerCountry]
        );
      } else {
        self.customPrintContent = self.customPrintContent.replace(
          /\${客户国家}/g,
          ""
        );
      }

      self.customPrintContent = self.customPrintContent.replace(
        /\${客户省份}/g,
        self.printBargain.customerProvince || ""
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户城市}/g,
        self.printBargain.customerCity || ""
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户地址}/g,
        self.printBargain.customerAddress || ""
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户邮编}/g,
        self.printBargain.customerZipcode || ""
      );
      if (self.printBargain.orders.length !== 0) {
        let orderContents = "";
        let orderContentsSimple = "";
        let orderContentsWidthImage = "";
        let orderContentsSimpleWidthImage = "";
        let orderContents5 = "";
        //=====
        for (const orderIndex in self.printBargain.orders) {
          const orderSequence = parseInt(orderIndex) + 1;
          let orderRemark = "";
          if (self.printBargain.orders[orderIndex].remark != null) {
            orderRemark = self.printBargain.orders[orderIndex].remark.replace(
              /<p>/g,
              "<p style='margin: 0; padding: 0'>"
            );
          }
          const subTotal = Util.toFixed(
            self.printBargain.orders[orderIndex].price *
              self.printBargain.orders[orderIndex].quantity +
              self.printBargain.orders[orderIndex].extraCharge,
            3
          );
          // ====1
          let orderContent =
            "<tr style='border: 1px solid black;  text-align: center'>" +
            "<td style='border: 1px solid black;'>" +
            orderSequence +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].serialNo +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].productBrand || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].categoryName || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].productNo +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            (self.printBargain.orders[orderIndex].color || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].size || "") +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            self.printBargain.orders[orderIndex].quantity +
            (self.printBargain.orders[orderIndex].unit || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].handOverAt || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            currencySymbol +
            self.printBargain.orders[orderIndex].productPrice +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].discountRate || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            currencySymbol +
            self.printBargain.orders[orderIndex].price +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            (self.printBargain.orders[orderIndex].extraCharge || 0) +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            subTotal +
            "</td>" +
            "</tr>";
          if (orderRemark !== "") {
            orderContent =
              orderContent +
              "<tr v-if='' style='border: 1px solid black;'>" +
              "<td style='border: 1px solid black; text-align: center'>备注:</td>" +
              "<td colspan='14' style='border: 1px solid black;; text-align: left'>" +
              orderRemark +
              "</td>" +
              "</tr>";
          }
          orderContents = orderContents + orderContent;
          // =====2
          const orderContentSimple =
            "<tr style='border: 1px solid black;  text-align: center'>" +
            "<td style='border: 1px solid black;'>" +
            orderSequence +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].productNo +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            (self.printBargain.orders[orderIndex].color || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].size || "") +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            self.printBargain.orders[orderIndex].quantity +
            (self.printBargain.orders[orderIndex].unit || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].handOverAt +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            currencySymbol +
            self.printBargain.orders[orderIndex].price +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            (self.printBargain.orders[orderIndex].extraCharge || 0) +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            subTotal +
            "</td>" +
            "</tr>";
          if (orderRemark !== "") {
            orderContentSimple =
              orderContentSimple +
              "<tr v-if='' style='border: 1px solid black;'>" +
              "<td style='border: 1px solid black; text-align: center'>备注:</td>" +
              "<td colspan='14' style='border: 1px solid black;; text-align: left'>" +
              orderRemark +
              "</td>" +
              "</tr>";
          }
          orderContentsSimple = orderContentsSimple + orderContentSimple;

          // ====3
          let orderContentWidthImage =
            "<tr style='border: 1px solid black;  text-align: center'>" +
            "<td style='border: 1px solid black;'>" +
            orderSequence +
            "</td>" +
            "<td style='border: 1px solid black;width:60px;'><image src='" +
            self.printBargain.orders[orderIndex].firstImage +
            "' style='width:60px;height: auto;'></td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].serialNo +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].productBrand || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].categoryName || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].productNo +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            (self.printBargain.orders[orderIndex].color || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].size || "") +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            self.printBargain.orders[orderIndex].quantity +
            (self.printBargain.orders[orderIndex].unit || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].handOverAt +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            currencySymbol +
            self.printBargain.orders[orderIndex].productPrice +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].discountRate || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            currencySymbol +
            self.printBargain.orders[orderIndex].price +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            (self.printBargain.orders[orderIndex].extraCharge || 0) +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            subTotal +
            "</td>" +
            "</tr>";
          if (orderRemark !== "") {
            orderContentWidthImage =
              orderContentWidthImage +
              "<tr v-if='' style='border: 1px solid black;'>" +
              "<td style='border: 1px solid black; text-align: center'>备注:</td>" +
              "<td colspan='15' style='border: 1px solid black;; text-align: left'>" +
              orderRemark +
              "</td>" +
              "</tr>";
          }
          orderContentsWidthImage =
            orderContentsWidthImage + orderContentWidthImage;
          // =====4
          const orderContentSimpleWidthImage =
            "<tr style='border: 1px solid black;  text-align: center'>" +
            "<td style='border: 1px solid black;'>" +
            orderSequence +
            "</td>" +
            "<td style='border: 1px solid black;width:60px;'><image src='" +
            self.printBargain.orders[orderIndex].firstImage +
            "' style='width:60px;height: auto;'></td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].productNo +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            (self.printBargain.orders[orderIndex].color || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].size || "") +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            self.printBargain.orders[orderIndex].quantity +
            (self.printBargain.orders[orderIndex].unit || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].handOverAt +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            currencySymbol +
            self.printBargain.orders[orderIndex].price +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            (self.printBargain.orders[orderIndex].extraCharge || 0) +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            subTotal +
            "</td>" +
            "</tr>";
          if (orderRemark !== "") {
            orderContentSimpleWidthImage =
              orderContentSimpleWidthImage +
              "<tr v-if='' style='border: 1px solid black;'>" +
              "<td style='border: 1px solid black; text-align: center'>备注:</td>" +
              "<td colspan='15' style='border: 1px solid black;; text-align: left'>" +
              orderRemark +
              "</td>" +
              "</tr>";
          }
          orderContentsSimpleWidthImage =
            orderContentsSimpleWidthImage + orderContentSimpleWidthImage;

          // ====1
          let orderContent5 =
            "<tr style='border: 1px solid black;  text-align: center'>" +
            "<td style='border: 1px solid black;'>" +
            orderSequence +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printBargain.orders[orderIndex].productNo +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            (self.printBargain.orders[orderIndex].color || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printBargain.orders[orderIndex].size || "") +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            self.printBargain.orders[orderIndex].quantity +
            (self.printBargain.orders[orderIndex].unit || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            currencySymbol +
            self.printBargain.orders[orderIndex].price +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            (self.printBargain.orders[orderIndex].orderRemark || "") +
            "</td>" +
            "</tr>";
          orderContents5 = orderContents5 + orderContent5;
        }
        self.customPrintContent = self.customPrintContent.replace(
          /\${订单项}/g,
          orderTitle + orderContents + "</table>"
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${精简订单项}/g,
          orderTitleSimple + orderContentsSimple + "</table>"
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${带图片订单项}/g,
          orderTitleWidthImage + orderContentsWidthImage + "</table>"
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${带图片精简订单项}/g,
          orderTitleSimpleWidthImage +
            orderContentsSimpleWidthImage +
            "</table>"
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${订单项5}/g,
          orderTitleOrderContents5 + orderContents5 + "</table>"
        );
      } else {
        self.customPrintContent = self.customPrintContent.replace(
          /\${订单项}/g,
          ""
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${精简订单项}/g,
          ""
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${带图片订单项}/g,
          ""
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${带图片精简订单项}/g,
          ""
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${订单项5}/g,
          ""
        );
      }
      window.document.getElementById("customPrintContentSalesSlip").innerHTML =
        self.customPrintContent;
      self.print("printSalesSlipCustomDiv");
    },
    print(type) {
      if (type == "printByProductNoColorDiv") {
        this.printByProductNoColorDF = false;
      }
      this.printFunction(type);
    },
    //
    addOrder(row) {
      this.currentRowBargainUuid = row.uuid;
      this.addOrderDF = true;
    },
    addOrderClose() {
      this.addOrderDF = false;
      this.loadData();
    },
    // narrows ====
    narrowsBrandsGroups() {
      this.narrows.push([
        {
          label: this.$t("product.brand"),
          items: this.brands.map((brand) => {
            return {
              label: brand.name,
              key: brand.name,
              condition: { productBrand: brand.name },
            };
          }),
        },
        {
          label: this.$t("action.group"),
          items: this.groups.map((group) => {
            return {
              label: group,
              key: JSON.stringify(group),
              condition: { groupJson: JSON.stringify(group) },
            };
          }),
        },
      ]);
    },
    narrowsFinanceVerifyInfo() {
      if (!this.Permit.isFreeEdition()) {
        this.narrows[1].push({
          label: this.$t("bargain.financeVerifyInfo"),
          items: [
            {
              label: this.$t("verifyInfos.agree"),
              key: "financeVerifyAgree",
              condition: { financeVerify: "agree" },
            },
            {
              label: this.$t("verifyInfos.reject"),
              key: "financeVerifyReject",
              condition: { financeVerify: "reject" },
            },
            {
              label: this.$t("verifyInfos.no"),
              key: "financeVerifyNo",
              condition: { financeVerify: "no" },
            },
          ],
        });
      }
    },
    narrowsWorkflowStates() {
      const self = this;
      if (self.Permit.canActions("orderDealView")) {
        var states = Order.states_pre;
        if (self.Permit.canActionsConfigDealType("available")) {
          states = states.concat(Order.states_available);
        }
        if (self.Permit.canActionsConfigDealType("purchase")) {
          states = states.concat(Order.states_purchase);
        }
        if (self.Permit.canActionsConfigDealType("manufacture")) {
          states = states.concat(Order.states_manufacture);
        }
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: states.concat(Order.states_after).map((s) => {
              return {
                key: s,
                label: self.$t("orderStates." + s),
                condition: { workflowStates: [s] },
              };
            }),
          },
        ]);
      } else {
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: Order.states_no_permint.map((s) => {
              return {
                key: s.key,
                label: self.$t("orderStates." + s.key),
                condition: { workflowStates: s.workflowStates },
              };
            }),
          },
        ]);
      }
      if (window.location.href.indexOf("unconfirms") != -1) {
        self.initFilter = "confirming";
      }
    },
    //====
    copyBargain(row) {
      this.currentRowBargainId = row.id;
      this.copyBargainDF = true;
    },
    copyUpdated() {
      this.loadData();
      this.copyBargainDF = false;
      this.copyOrderDF = false;
    },
    //==========================

    // 删除订单
    canDelBargain(row) {
      if (row.orders && row.orders.length !== 0) {
        const workflowStates = row.orders.map((r) => r.workflowState);
        const workflowStatesSet = [...new Set(workflowStates)];
        if (
          workflowStatesSet.every((val) =>
            ["confirming", "pending"].includes(val)
          ) &&
          row.orders[0].follow
        ) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },

    confirmBargain(row) {
      const self = this;
      if (confirm("确认全部确认？")) {
        Order.confirmByBargainId(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("deleteBargain");
          } else {
            self.sysError();
          }
        });
      }
    },
    deleteBargain(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Bargain.delete(row.id).then(function (res) {
          if (res.status === 200) {
            // self.$message({
            //   message: self.$t("prompt.delSuccess"),
            //   type: "success",
            // });
            self.sysResult(res.data);
            self.loadData();
            self.$eventHub.$emit("deleteBargain");
          } else {
            self.sysError();
          }
        });
      }
    },
    //编辑加急
    editBargainHurry(row, rowIndex) {
      const self = this;
      Bargain.updateHurry(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.hurrySuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    //编辑地址
    canEditBargainAddress(row) {
      if (row.orders && row.orders.length !== 0) {
        const workflowStates = row.orders.map((r) => r.workflowState);
        if (
          !workflowStates.includes("shipped") &&
          !workflowStates.includes("partially") &&
          !workflowStates.includes("finished")
        ) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
    //编辑
    editBargain(row, rowIndex) {
      this.currentRowBargainId = row.id;
      this.currentRowIdx = rowIndex;
      this.editBargainDF = true;
    },
    bargainUpdated(bargain) {
      this.records[this.currentRowIdx].serialNo = bargain.serialNo;
      this.records[this.currentRowIdx].shopName = bargain.shopName;
      this.records[this.currentRowIdx].settleType = bargain.settleType;
      this.records[this.currentRowIdx].remark = bargain.remark;
      // 地址
      this.records[this.currentRowIdx].customerName = bargain.customerName;
      this.records[this.currentRowIdx].customerPhone = bargain.customerPhone;
      this.records[this.currentRowIdx].customerCountry =
        bargain.customerCountry;
      this.records[this.currentRowIdx].customerProvince =
        bargain.customerProvince;
      this.records[this.currentRowIdx].customerCity = bargain.customerCity;
      this.records[this.currentRowIdx].customerAddress =
        bargain.customerAddress;
      this.records[this.currentRowIdx].customerZipcode =
        bargain.customerZipcode;
      this.records[this.currentRowIdx].deliveryRemark = bargain.deliveryRemark;
      this.editBargainDF = false;
    },

    //批量 删除
    batchDelete() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      let canDeleteBargain = [];
      for (const row of self.selectRecords) {
        if (row.productQty == 0 && self.financeVerifyInfoDF(row)) {
          canDeleteBargain.push(row);
        }
      }
      if (canDeleteBargain.length === 0) {
        self.$message({
          message: "至少选择一条 产品数是0 的订单",
          type: "warning",
        });
        return;
      }
      self.batchDeleteDoing = true;
      Bargain.batchDelete(canDeleteBargain.map((b) => b.id)).then(function (
        res
      ) {
        self.batchDeleteDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 分配拥有人
    batchDistributiveOwner() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.distributiveOwnerType = "batch";
      self.distributiveOwnerObj.uuid = null;
      self.distributiveOwnerObj.ownerId = null;
      self.distributiveOwnerObj.ownerName = null;
      self.usersFilterValid = self.users.filter((u) => u.voidAt == null);
      self.distributiveOwnerDoing = false;
      self.distributiveOwnerDF = true;
    },
    distributiveOwner(row, index) {
      const self = this;
      self.distributiveOwnerType = "single";
      self.currentRowIdx = index;
      self.distributiveOwnerObj.uuid = row.uuid;
      self.usersFilterValid = self.users.filter((u) => u.voidAt == null);
      if (self.users.find((u) => u.id === row.ownerId) != null) {
        self.distributiveOwnerObj.ownerId = row.ownerId;
      }
      self.distributiveOwnerDoing = false;
      self.distributiveOwnerDF = true;
    },
    distributiveOwnerSubmit() {
      const self = this;
      self.$refs.distributiveOwnerObjForm.validate((valid) => {
        if (valid) {
          self.distributiveOwnerObj.ownerName = self.users.find(
            (u) => u.id === self.distributiveOwnerObj.ownerId
          ).name;
          if (self.distributiveOwnerType == "single") {
            self.distributiveOwnerDoing = true;
            Bargain.updataOwner(self.distributiveOwnerObj).then(function (res) {
              self.distributiveOwnerDoing = false;
              self.distributiveOwnerDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.distributiveSuccess"),
                  type: "success",
                });
                self.records[self.currentRowIdx].ownerName =
                  self.distributiveOwnerObj.ownerName;
              } else {
                self.sysError();
              }
            });
          } else {
            const data = self.selectRecords.map((s) => {
              return {
                ownerId: self.distributiveOwnerObj.ownerId,
                ownerName: self.distributiveOwnerObj.ownerName,
                bargainId: s.id,
                uuid: s.uuid,
              };
            });
            self.distributiveOwnerDoing = true;
            Bargain.batchUpdateOwner(data).then(function (res) {
              self.distributiveOwnerDoing = false;
              self.distributiveOwnerDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.distributiveSuccess"),
                  type: "success",
                });
                for (let bargain of self.selectRecords) {
                  bargain.ownerName = self.distributiveOwnerObj.ownerName;
                }
              } else {
                self.sysError();
              }
            });
          }
        } else {
          return false;
        }
      });
    },

    // 添加收款
    addPayment(row, index) {
      const self = this;
      self.currentRowIdx = index;
      self.addPaymentObj.bargainId = row.id;
      self.addPaymentObj.currency = row.currency;
      self.addPaymentObj.paidAt = Util.formatDate(new Date());
      self.addPaymentObj.total = null;
      self.addPaymentObj.type = null;
      self.addPaymentObj.explain = null;
      self.addPaymentObj.voucher = null;
      self.addPaymentObj.type = "receivables";
      self.addPaymentObj.customerId = row.customerId;
      axios
        .all([
          PayMethod.findByTypes({ types: PayMethod.saleTypes }),
          Customer.findById(row.customerId),
        ])
        .then(
          axios.spread(function (payMethods, customers) {
            if (payMethods.status === 200) {
              self.payMethods = payMethods.data;
            } else {
              self.sysError();
            }
            if (customers.data.code === 200) {
              self.customer = customers.data.entity;
              if (row.currency === "CNY" && self.customer) {
                self.payMethods.push({
                  id: -1,
                  // name: "账户余额(¥" + self.customer.balance + ")",
                  name: "账户余额",
                });
              }
            } else {
              self.customer = null;
            }
            self.addPaymentDoing = false;
            self.addPaymentDF = true;
          })
        );
    },
    blurJudgeBalance() {
      const self = this;
      if (
        self.customer != null &&
        self.addPaymentObj.payMethodId === -1 &&
        self.addPaymentObj.type === "receivables" &&
        self.addPaymentObj.total > self.customer.balance
      ) {
        self.addPaymentObj.payMethodId = null;
        self.$message({
          message: self.$t("prompt.customerBalanceNotEnougth"),
          type: "warning",
        });
      }
    },
    addPaymentSubmit() {
      const self = this;
      self.$refs.addPaymentObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.addPaymentObj.total)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("payment.total")]),
              type: "warning",
            });
            return;
          }
          if (self.addPaymentObj.type === "return") {
            self.addPaymentObj.total = -self.addPaymentObj.total;
          }
          self.addPaymentObj.payMethodName = self.payMethods.find(
            (p) => p.id === self.addPaymentObj.payMethodId
          ).name;
          self.addPaymentObj.paidAt = Util.formatDate(
            self.addPaymentObj.paidAt
          );
          self.addPaymentDoing = true;
          Payment.create(self.addPaymentObj).then(function (res) {
            if (res.data.code === 201) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.records[self.currentRowIdx].payAmount =
                self.records[self.currentRowIdx].payAmount +
                Number(self.addPaymentObj.total);
              self.records[self.currentRowIdx].differAmount =
                self.records[self.currentRowIdx].differAmount -
                Number(self.addPaymentObj.total);
              self.records[self.currentRowIdx].financeAudit = null;
            } else {
              self.sysError();
            }
            self.addPaymentDoing = false;
            self.addPaymentDF = false;
          });
        } else {
          return false;
        }
      });
    },

    // -----财务审核权限
    financeVerifyInfoDF(row) {
      const financeVerifyInfoDF =
        this.Permit.currentTenant().config.financeVerifyStrict === false ||
        (this.Permit.currentTenant().config.financeVerifyStrict &&
          (row.financeAudit == null ||
            (row.financeAudit != null &&
              row.financeAudit.dealType === "reject")));
      return financeVerifyInfoDF;
    },

    //=========
    showBargain(row) {
      this.currentRowBargainId = row.id;
      this.showBargainDF = true;
    },
    //=====
    //导入 亚马逊
    importAmazon(shopId) {
      const self = this;
      self.$router.push({
        name: "omsBargainsImportAmazon",
        query: { shopId: shopId },
      });
    },
    // 下载
    download(type) {
      const self = this;
      if (type === "search") {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        Vue.set(data, "excelType", "general");
        self.downloadData(data);
      }
      if (type == "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.selectRecords.map((c) => c.id),
          excelType: "general",
        };
        self.downloadData(data);
      }
      if (type === "ePost") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          ids: self.selectRecords.map((c) => c.id),
          excelType: "ePost",
        };
        self.downloadData(data);
      }
      if (type === "middlePost") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          ids: self.selectRecords.map((c) => c.id),
          excelType: "middlePost",
        };
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Bargain.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    //删除分组
    deleteGroup(row, rowIndex, item) {
      const self = this;
      const groupArr = JSON.parse(row.groupJson);
      Bargain.updateGroup({
        uuid: row.uuid,
        groupJson: JSON.stringify(groupArr.filter((g) => g !== item)),
      }).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delGroupSuccess"),
            type: "success",
          });
          self.records[rowIndex].groupJson = JSON.stringify(
            groupArr.filter((g) => g !== item)
          );
        } else {
          self.sysError();
        }
      });
    },
    // 加入分组
    batchAddGroup(group) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const obj = {
        uuids: self.selectRecords.map((cb) => cb.uuid),
        groups: [group],
      };
      Bargain.groupsInsertBatch(obj).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addGroupSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 收款完毕
    batchPaymentCompleted() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const differAmountBargains = self.selectRecords.filter(
        (bargain) => bargain.differAmount > 0 && bargain.settleType === "now"
      );
      if (differAmountBargains.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneDataExistDifferAmount"));
        return;
      }
      const datas = differAmountBargains.map((bargain) => {
        return {
          type: "receivables", // return
          total: bargain.differAmount,
          payMethodId: 0,
          payMethodName: "抹零",
          explain: null,
          currency: bargain.currency,
          bargainId: bargain.id,
          paidAt: new Date(),
          voucher: null,
          settlementId: 0, // 先付款
          customerId: null,
        };
      });
      if (confirm(this.$t("prompt.confirmBatchPaymentCompleted"))) {
        Payment.insertBatch(datas).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.dealSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    //
    dataProvider(params) {
      return Bargain.webSearchNoOrders(params);
    },
  },
};
</script>
<style scoped>
.group {
  float: left;
  margin-left: 10px;
  border: 1px solid rgba(64, 158, 255, 0.2);
  color: #409eff;
  background: rgba(64, 158, 255, 0.1);
  padding: 0px 4px;
  border-radius: 3px;
  font-size: 12px;
}
</style>